import { QuestionCircleOutlined } from '@ant-design/icons';
import { SelectLang as UmiSelectLang } from '@umijs/max';
import React from 'react';
import { AvatarDropdown, AvatarName } from './AvatarDropdown';

export type SiderTheme = 'light' | 'dark';

export const SelectLang: React.FC = () => {
  return (
    <UmiSelectLang
      style={{
        padding: 4,
      }}
    />
  );
};

export const Question: React.FC = () => {
  return null;
  // 问号文档
  // return (
  //   <a
  //     href="https://pro.ant.design/docs/getting-started"
  //     target="_blank"
  //     rel="noreferrer"
  //     style={{
  //       display: 'inline-flex',
  //       padding: '4px',
  //       fontSize: '18px',
  //       color: 'inherit',
  //     }}
  //   >
  //     <QuestionCircleOutlined />
  //   </a>
  // );
};

const containerStyle: React.CSSProperties = {
  position: 'fixed',
  top: 12,
  right: 24,
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  zIndex: 1000,
};

const RightContent: React.FC = () => (
  <div style={containerStyle}>
    <Question />
    <SelectLang />
    <AvatarDropdown menu>
      <AvatarName />
    </AvatarDropdown>
  </div>
);

export default RightContent;
